import {
  autoReplyDraftRequestSchema,
  autoReplyDraftResponseSchema,
  autoReplySendRequestSchema,
  autoReplySendResponseSchema,
  leadScoringRequestSchema,
  leadScoringResponseSchema,
  type AutoReplyDraftRequest,
  type AutoReplyDraftResponse,
  type AutoReplySendRequest,
  type AutoReplySendResponse,
  type LeadScoringRequest,
  type LeadScoringResponse,
} from "@io-spoke/contracts/leadScoring";
import { getApiClient } from "./apiClient";

function firstIssueMessage(error: { issues?: { message?: string }[] }, fallback: string) {
  return error.issues?.[0]?.message ?? fallback;
}

export async function scoreLead(
  payload: LeadScoringRequest
): Promise<LeadScoringResponse> {
  const parsed = leadScoringRequestSchema.safeParse(payload);
  if (!parsed.success) {
    const message = firstIssueMessage(parsed.error, "Invalid lead scoring payload.");
    throw new Error(message);
  }

  const api = getApiClient();
  const response = await api.post("/leads/score", parsed.data);
  const result = leadScoringResponseSchema.safeParse(response.data);
  if (!result.success) {
    const message = firstIssueMessage(result.error, "Lead scoring response was invalid.");
    throw new Error(message);
  }
  return result.data;
}

export async function createAutoReplyDraft(
  payload: AutoReplyDraftRequest
): Promise<AutoReplyDraftResponse> {
  const parsed = autoReplyDraftRequestSchema.safeParse(payload);
  if (!parsed.success) {
    const message = firstIssueMessage(parsed.error, "Invalid auto-reply payload.");
    throw new Error(message);
  }

  const api = getApiClient();
  const response = await api.post("/leads/auto-reply", parsed.data);
  const result = autoReplyDraftResponseSchema.safeParse(response.data);
  if (!result.success) {
    const message = firstIssueMessage(result.error, "Auto-reply response was invalid.");
    throw new Error(message);
  }
  return result.data;
}

export async function sendAutoReply(
  payload: AutoReplySendRequest
): Promise<AutoReplySendResponse> {
  const parsed = autoReplySendRequestSchema.safeParse(payload);
  if (!parsed.success) {
    const message = firstIssueMessage(parsed.error, "Invalid auto-reply send payload.");
    throw new Error(message);
  }

  const api = getApiClient();
  const response = await api.post("/leads/auto-reply/send", parsed.data);
  const result = autoReplySendResponseSchema.safeParse(response.data);
  if (!result.success) {
    const message = firstIssueMessage(result.error, "Auto-reply send response was invalid.");
    throw new Error(message);
  }
  return result.data;
}
